import React from "react";
import MetricFormatter from "dashboards/MetricFormatter";
import ReactDOMServer from "react-dom/server";
import { ReactSVG } from "react-svg";
import jsDig from "utils/jsDig";
import getCurrencyDetails from "utils/getCurrencyDetails";
import { startCase, camelCase } from "lodash";
import GetFormatter from "dashboards/GetFormatter";

function changeColor(color1, color2, percentage) {
  var hex = function (x) {
    x = x.toString(16);
    return x.length == 1 ? "0" + x : x;
  };

  var r = Math.ceil(parseInt(color1.substring(0, 2), 16) * percentage + parseInt(color2.substring(0, 2), 16) * (1 - percentage));
  var g = Math.ceil(parseInt(color1.substring(2, 4), 16) * percentage + parseInt(color2.substring(2, 4), 16) * (1 - percentage));
  var b = Math.ceil(parseInt(color1.substring(4, 6), 16) * percentage + parseInt(color2.substring(4, 6), 16) * (1 - percentage));

  return hex(r) + hex(g) + hex(b);
}

const mapUrl = require("images/us-with-labels.svg");

class ChartLocation extends React.Component {
  constructor(props) {
    super(props);
    this.svgRef = React.createRef();
    this.max = jsDig(["spend"], this.props.data) ? Math.max(...Object.values(jsDig(["spend"], this.props.data))) : 0;
  }

  componentDidMount() {}

  setupSvg(svg) {
    // The graph actually shows only spend except on hover
    let data = jsDig(["spend"], this.props.data) ? jsDig(["spend"], this.props.data) : [];
    let statePercentages = {};
    let sumOfAllStateSpend = Object.values(data).reduce((accumlulator, item) => {
      return accumlulator + item;
    }, 0);

    Object.keys(data).forEach((key, i, arr) => {
      statePercentages[key] = (data[key] / sumOfAllStateSpend) * 100;
    });

    Array.from(svg.children).forEach((child, i, arr) => {
      if (child.getAttribute("sodipodi:nodetypes") == "cccc" || child.getAttribute("sodipodi:nodetypes") == "ccc") return;

      if (child.tagName == "g") {
        Array.from(child.children).forEach((secondaryChild, i, arr) => {
          let statePercentage = statePercentages[secondaryChild.id.substring(0, 2)];
          if (!statePercentage) statePercentage = 0;
          let scaledStatePercentage = statePercentage * 12;
          if (scaledStatePercentage >= 100) scaledStatePercentage = 100;
          let stateColor = changeColor("42BA96", "3291C1", scaledStatePercentage / 100);
          secondaryChild.style.fill = "#" + stateColor;
          if (secondaryChild.id == "MI-" || secondaryChild.id == "SP-") {
            secondaryChild.id = "MI";
          }

          if (data[secondaryChild.id.substring(0, 2)] && $("#" + secondaryChild.id).length > 0) {
            let tooltipMsg = secondaryChild.id.substring(0, 2) + "<br>";
            this.props.metricsEnabled.forEach((metricKey, index) => {
              let Formatter = GetFormatter({ metricName: metricKey });
              const metricTitle = _.startCase(_.camelCase(metricKey));
              const metricValue = ReactDOMServer.renderToString(<Formatter value={jsDig([metricKey, secondaryChild.id.substring(0, 2)], this.props.data)} baseCurrency={this.props.baseCurrency} displayCurrency={this.props.displayCurrency} />);
              tooltipMsg += `${metricTitle}: ${metricValue}${index < this.props.metricsEnabled.length ? "<br>" : ""}`;
            });

            $("#" + secondaryChild.id)
              .get(0)
              .setAttribute("data-toggle", "tooltip");
            $("#" + secondaryChild.id)
              .get(0)
              .setAttribute("data-html", "true");
            $("#" + secondaryChild.id)
              .get(0)
              .setAttribute("data-trigger", "manual");
            $("#" + secondaryChild.id)
              .get(0)
              .setAttribute("title", tooltipMsg);
            $("#" + secondaryChild.id)
              .get(0)
              .setAttribute("data-placement", "auto");
            $("#" + secondaryChild.id)
              .get(0)
              .setAttribute(
                "data-template",
                '<div class="tooltip geoMapTooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
              );

            svg.querySelector("#" + secondaryChild.id).addEventListener("mouseover", (event) => {
              $(secondaryChild.id).tooltip("show");
            });

            svg.querySelector("#" + secondaryChild.id).addEventListener("mouseleave", (event) => {
              $("#" + secondaryChild.id).tooltip("hide");
            });

            $("#" + secondaryChild.id)
              .get(0)
              .addEventListener("mouseover", (event) => {
                $("#" + secondaryChild.id).tooltip("show");
              });

            $("#" + secondaryChild.id)
              .get(0)
              .addEventListener("mouseleave", (event) => {
                $("#" + secondaryChild.id).tooltip("hide");
              });

            $("#" + secondaryChild.id)
              .siblings("rect")
              .on("mouseover", () => {
                $("#" + secondaryChild.id).tooltip("show");
              });

            $("#" + secondaryChild.id)
              .siblings("rect")
              .on("mouseleave", () => {
                $("#" + secondaryChild.id).tooltip("hide");
              });
          }
        });
      } else if (child.tagName == "text") {
        child.style.fill = "white";
      } else if (child.tagName == "path") {
        let statePercentage = statePercentages[child.id.substring(0, 2)];
        if (!statePercentage) statePercentage = 0;
        let scaledStatePercentage = statePercentage * 12;
        if (scaledStatePercentage >= 100) scaledStatePercentage = 100;
        let stateColor = changeColor("42BA96", "3291C1", scaledStatePercentage / 100);
        child.style.fill = "#" + stateColor;

        if (data[child.id.substring(0, 2)]) {
          let tooltipMsg = child.id.substring(0, 2) + "<br>";
          this.props.metricsEnabled.forEach((metricKey, index) => {
            let Formatter = GetFormatter({ metricName: metricKey });
            const metricTitle = _.startCase(_.camelCase(metricKey));
            const metricValue = ReactDOMServer.renderToString(<Formatter value={jsDig([metricKey, child.id.substring(0, 2)], this.props.data)} baseCurrency={this.props.baseCurrency} displayCurrency={this.props.displayCurrency} />);
            tooltipMsg += `${metricTitle}: ${metricValue}${index < this.props.metricsEnabled.length ? "<br>" : ""}`;
          });

          if ($("path#" + child.id).get(0)) {
            $("path#" + child.id)
              .get(0)
              .setAttribute("data-toggle", "tooltip");
            $("path#" + child.id)
              .get(0)
              .setAttribute("data-trigger", "manual");
            $("path#" + child.id)
              .get(0)
              .setAttribute("title", tooltipMsg);
            $("path#" + child.id)
              .get(0)
              .setAttribute("data-placement", "auto");
            $("path#" + child.id)
              .get(0)
              .setAttribute("data-html", "true");
            $("path#" + child.id)
              .get(0)
              .setAttribute(
                "data-template",
                '<div class="tooltip geoMapTooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
              );

            svg.querySelector("#" + child.id).addEventListener("mouseover", (event) => {
              $("path#" + child.id).tooltip("show");
            });

            svg.querySelector("#" + child.id).addEventListener("mouseleave", (event) => {
              $("path#" + child.id).tooltip("hide");
            });

            $("path#" + child.id)
              .get(0)
              .addEventListener("mouseover", (event) => {
                $("path#" + child.id).tooltip("show");
              });

            $("path#" + child.id)
              .get(0)
              .addEventListener("mouseleave", (event) => {
                $("path#" + child.id).tooltip("hide");
              });
          }
        }
      }
    });
  }
  render() {
    let currencyDetails = getCurrencyDetails(this.props.displayCurrency);
    return (
      <div ref={this.svgRef} className="chart-location">
        <div className="text-center">
          <ReactSVG
            src={(this.props.urlOrigin ? this.props.urlOrigin : "/") + "datapulse" + mapUrl}
            afterInjection={(err, svg) => this.setupSvg(svg)}
            beforeInjection={(svg) => {
              svg.setAttribute("style", "max-width: 100%");
            }}
          />
        </div>
        <div className="legend">
          <span>{ currencyDetails.prefix }0{ currencyDetails.suffix }</span>
          <span className="legend-gradient"></span>
          <span>
            <MetricFormatter.Revenue value={this.max} baseCurrency={this.props.baseCurrency} displayCurrency={this.props.displayCurrency} />
          </span>
        </div>
      </div>
    );
  }
}

export default ChartLocation;
